const collectionThumbnailSize = 32;

const cellPadding = 10;

const cellContentIdealHeight = 40;
const cellContentMinHeight = cellContentIdealHeight - cellPadding * 2;

const sortActionFontSize = 12;
const sortActionPadding = 6;

export const tokens = {
    table: {
        radius: 10,
    },
    thead: {
        height: cellPadding * 2 + sortActionPadding * 2 + sortActionFontSize,
    },
    row: {
        gap: 6,
    },
    cell: {
        padding: cellPadding,
    },
    cellContent: {
        idealHeight: cellContentIdealHeight,
        minHeight: cellContentMinHeight,
    },
    skeleton: {
        heightOffset: 2,
    },
    collection: {
        gap: cellPadding,
        minWidth: collectionThumbnailSize * 4 + cellPadding * 2,
        thumbnail: {
            size: collectionThumbnailSize,
            mashSize: collectionThumbnailSize * 2,
            radius: collectionThumbnailSize / 4,
        },
        details: {
            gap: 4,
        },
        title: {
            fontSize: 13,
        },
        subtitle: {
            fontSize: 12,
            iconSize: 10,
        },
    },
    dataValue: {
        gap: 4,
        fontSize: 12,
    },
    sortAction: {
        spacing: sortActionPadding,
        fontSize: sortActionFontSize,
        iconSize: 10,
    },
    loadAction: {
        fontSize: 14,
    },
};
